import { Toaster } from 'components/notification/Toaster';
import useOutletsActions from 'dataflow/billingPortal/actions/useOutlet.actions';
import { func_validation, isObjectNotEmpty } from 'functions';
import { useRef, useState } from 'react';

export function useTableActions(selectedOutlets) {
    const { activateOutlet, suspendOutlet, deleteOutlet, revertDeleteOutlet, addOutletActivationExclusion, removeOutletActivationExclusion, removeSuspendDate } = useOutletsActions();

    const [isRerenderingRequired, setIsRerenderingRequired] = useState();
    const updatingSingleRowPos = useRef();

    function getComIdFromOutlet(outletDetails = {}) {
        let comId = outletDetails?.ComId;
        if (!comId) {
            comId = outletDetails?.original?.ComId;
        }
        return comId;
    }

    function updateOutletByAction(comId, locationId, actionType) {
        if (!(comId && locationId)) {
            return;
        }

        if (actionType === "suspend") {
            suspendOutlet(comId, locationId);
        } else if (actionType === "activate") {
            activateOutlet(comId, locationId);
        } else if (actionType === "delete") {
            deleteOutlet(comId, locationId);
        } else if (actionType === "revert") {
            revertDeleteOutlet(comId, locationId);
        } else if (actionType === "addActivationExclusion") {
            addOutletActivationExclusion(comId, locationId);
        } else if (actionType === "removeActivationExclusion") {
            removeOutletActivationExclusion(comId, locationId);
        } else if (actionType === "removeSuspendDate") {
            removeSuspendDate(comId, locationId);
        }
    }

    function updateMultipleOutlets(actionType) {
        if (func_validation.isArrayNotEmpty(selectedOutlets)) {
            updatingSingleRowPos.current = undefined;
            setIsRerenderingRequired(Math.random());

            selectedOutlets.map((outletDetails) => {
                let locationId = outletDetails?.ID;
                let comId = getComIdFromOutlet(outletDetails);
                updateOutletByAction(comId, locationId, actionType);
            })
        }
        else {
            Toaster({
                type: "info",
                msg: "Please select at least 1 row"
            })
        }
    }


    function updateSingleOutlet(outletDetails, actionType) {
        if (isObjectNotEmpty(outletDetails)) {
            let rowIndex = outletDetails?.index;
            updatingSingleRowPos.current = rowIndex;
            setIsRerenderingRequired(Math.random());

            let locationId = outletDetails?.original?.ID;
            let comId = getComIdFromOutlet(outletDetails);
            updateOutletByAction(comId, locationId, actionType);
        }
        else {
            Toaster({
                type: "info",
                msg: "Table data not loaded properly. Try refreshing the page.",
                timer: 7000
            })
        }
    }

    return {
        updateMultipleOutlets, updateSingleOutlet,
        updatingSingleRowPos,
    }
}